import { render, staticRenderFns } from "./ProcedimentosForm.vue?vue&type=template&id=25e6ae10"
import script from "./ProcedimentosForm.vue?vue&type=script&lang=js"
export * from "./ProcedimentosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports